import React, {useEffect, useState} from 'react';
import {getOrganizationProperties} from "../api/HomeApi";
import {showError} from "../../../utils/toastHelper";

const OrganizationPropertise = () => {
    const [organization , setOrganization] = React.useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const data = await getOrganizationProperties();
                setOrganization(data?.data );
            } catch (err) {
                showError( err);
            } finally {
                setLoading(false)
            }
        };
        fetchSlides();
    }, []);


    return (
        <section className="container">
            <div className='row  mb-5 pb-5 mt-0'>
                {
                    !loading && organization.map(property => {
                        if (property.in_service_app === "1") {
                            return (
                                <div className="col-12 col-md-3 px-md-1">
                                    <div className="  card my-1 border-0 px-2 mx-0 ">
                                        <div className="row py-2">
                                            <div className="col-3 text-center">
                                                <img src={property.image} alt={property.title} className='w-100'/>
                                            </div>
                                            <div className="col-9 pt-2">
                                            <span
                                                className='fw-bold  text-primary-color '>{property.title}</span>
                                                <p className='mt-2 text-small-2 text-muted'>
                                                    {property.description}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )
                        }

                    })
                }

            </div>
        </section>

    );
};

export default OrganizationPropertise;
